import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { OverlayElement, OverlayElementType } from "./OverlayElement";

export class InfoFaxReceiverContactOverlayElement extends OverlayElement {
    public Name: string;
    public FaxNumber: string;
    public RecipientContactDirectoryEntityId: string;
    public RecipientContactDirectoryEntityType: DirectoryEntityType;

    public constructor(init?: Partial<InfoFaxReceiverContactOverlayElement>) {
        super(OverlayElementType.InfoFaxReceiverContact);
        Object.assign(this, init);
    }
}
